import { render, staticRenderFns } from "./ConfigurazioneAgendaBoxListPage.vue?vue&type=template&id=0598a628"
import script from "./ConfigurazioneAgendaBoxListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneAgendaBoxListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports